// Public participation slice. Loads the compact { countyFips: status } map for
// the intake form's "Alabama Participation" choropleth from the dedicated
// public endpoint. Failures are non-fatal — the map simply renders every county
// as the default 'interest_not_expressed'.
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../api/public-client.js';

export const fetchParticipation = createAsyncThunk(
  'participation/fetch',
  async (_arg, { rejectWithValue }) => {
    try {
      const { participation } = await apiFetch('/api/participation');
      return participation ?? {};
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const slice = createSlice({
  name: 'participation',
  initialState: { map: {}, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchParticipation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchParticipation.fulfilled, (state, action) => {
        state.loading = false;
        state.map = action.payload;
      })
      .addCase(fetchParticipation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Failed to load participation.';
      });
  },
});

export const selectParticipationMap = (state) => state.participation.map;

export default slice.reducer;
